import React from 'react'
import styles from './Topo.scss'
import cx from 'classnames'

export class Topo extends React.PureComponent {
  static defaultProps = {
    dark: false
  }

  render () {
    const {className, dark, mint, children, ...props} = this.props
    return (
      <div className={cx(styles.Topo, dark && styles.dark, mint && styles.mint, className)} {...props}>
        {children}
      </div>
    )
  }
}
